import apiClient from './base/apiClient'

export interface Notice {
  id: string
  title: string
  date: string
  content: string
}

export interface NoticeListResponse {
  notices: Notice[]
}

export const noticeApi = {
  getNotices: async (): Promise<NoticeListResponse> => {
    const response = await apiClient.get<NoticeListResponse>('/notices')
    return response.data
  },
}
